import { BASE_ASSETS } from "@assets/templates/constants";
import type { TemplateDefinition } from "@assets/templates/types";
import { DocumentInputContentV1 } from "@demo/types/documentContent";

export const convPointingDemoExample: TemplateDefinition = {
  mode: "compose",
  slug: "conv-pointing-demo-example",
  version: 1,
  title: "Personal agent",
  description: "Assess visual context",
  subdescription: "Read the scene and decide whether it's safe to cross",
  thumbnailUuid: BASE_ASSETS.convPointingDemoExample.uuid,
  assets: [BASE_ASSETS.convPointingDemoExample],
  request: {
    model: "perceptron-mk1.5",
    system: [],
    user: [
      {
        type: "media",
        value: [
          {
            type: "image",
            value: {
              uuid: BASE_ASSETS.convPointingDemoExample.uuid,
              extension: BASE_ASSETS.convPointingDemoExample.extension,
              annotations: { points: [], boundingBoxes: [] },
            },
          },
        ],
      },
      {
        type: "paragraph",
        value: {
          type: "text",
          value: "Determine whether it is safe to cross the street. Look for signage and moving traffic.",
        },
      },
    ],
    outputAnnotations: true,
    variables: {},
    annotationFormat: null,
    enableThinking: true,
  } satisfies DocumentInputContentV1,
};
